import sdkProvider from "../helpers/sdk-provider";

export const isAuthenticated = async () => {
  const identity = await sdkProvider("identity");
  return await identity.customer.isAuthenticated();
};

export const promptLogin = async () => {
  const identity = await sdkProvider("identity");
  identity.login();
};

export const getFirstName = async () => {
  if (await isAuthenticated()) {
    const identity = await sdkProvider("identity");
    return await identity.customer.firstName();
  } else {
    return null;
  }
};

export const getCustomerId = async () => {
  if (await isAuthenticated()) {
    const identity = await sdkProvider("identity");
    return await identity.customer.customerId();
  } else {
    return null;
  }
};

export const getAuthHeader = async () => {
  if (await isAuthenticated()) {
    const identity = await sdkProvider("identity");
    return await identity.getAuthHeader();
  } else {
    return null;
  }
};
